export default __webpack_public_path__ + "static/media/241.72d22660.gif";